
export const SET_SELECTROWKEYS= 'SET_SELECTROWKEYS';



export const setSelectRowKeys = (rowRecord) => ({
    type: SET_SELECTROWKEYS,
    rowRecord:rowRecord,
});





// WEBPACK FOOTER //
// ./src/redux/actions/selectedRowKey.js